import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// App Components
import { AppShell } from './components/AppShell';
import { CommandCenter } from './components/CommandCenter';
import { CalendarGrid } from './components/CalendarGrid';
import { AnalyticsDashboard } from './components/AnalyticsDashboard';
import { SettingsPanel } from './components/SettingsPanel';
// Marketing Components
import { MarketingLayout } from './components/marketing/MarketingLayout';
import { LandingPage } from './pages/marketing/LandingPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        {/* Marketing */}
        <Route path="/" element={<MarketingLayout data-id="element-3">
              <LandingPage data-id="element-4" />
            </MarketingLayout>} data-id="element-2" />

        {/* App */}
        <Route path="/app" element={<AppShell data-id="element-6">
              <CommandCenter data-id="element-7" />
            </AppShell>} data-id="element-5" />
        <Route path="/app/calendar" element={<AppShell data-id="element-9">
              <CalendarGrid data-id="element-10" />
            </AppShell>} data-id="element-8" />
        <Route path="/app/analytics" element={<AppShell data-id="element-12">
              <AnalyticsDashboard data-id="element-13" />
            </AppShell>} data-id="element-11" />
        <Route path="/app/settings" element={<AppShell data-id="element-15">
              <SettingsPanel data-id="element-16" />
            </AppShell>} data-id="element-14" />
      </Routes>
    </Router>;
}